// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_FiscalConfigResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for PUT /payments/accounts/fiscal_config/{id}
 *
 * Passthrough updated sanitized subaccount object.
 * Shape owned by subaccounts_model->sanitizeForFrontend().
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_FiscalConfigResponseDados = unknown[];

export type SubaccountsFranchises_FiscalConfigResponse = ApiResponse<SubaccountsFranchises_FiscalConfigResponseDados>;

registerResponseContract('SubaccountsFranchises_FiscalConfigResponse', {})
